import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const DURATION = 2
const STAGGER = 0.15

let mm

export const statCards = () => {

	if (mm) mm.revert()

	let sections = document.querySelectorAll('[data-animation="stat-cards"]')

	if (!sections.length) return

	mm = gsap.matchMedia()

	mm.add({
		motion: '(prefers-reduced-motion: no-preference)',
	}, context => {

		let { motion } = context.conditions

		if (!motion) return

		let restore = []

		sections.forEach(section => {

			let stats = section.querySelector('.stat-list'),
				values = section.querySelectorAll('.value')

			if (!stats || !values.length) return

			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: stats,
					start: 'top 80%',
					toggleActions: 'play none none none',
				},
			})

			values.forEach((el, i) => {

				let original = el.textContent.trim(),
					// e.g. "101.73%" → prefix "", number "101.73", suffix "%"
					match = original.match(/^(\D*)([\d.,]+)(\D*)$/)

				if (!match) return

				let [, prefix, number, suffix] = match,
					target = parseFloat(number.replace(/,/g, '')),
					decimals = (number.split('.')[1] || '').length,
					// Keep thousands separators when the original has them ("£20,000")
					grouped = number.includes(','),
					format = value => grouped
						? value.toLocaleString('en-GB', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
						: value.toFixed(decimals),
					counter = { value: 0 },
					render = () => el.textContent = prefix + format(counter.value) + suffix

				render()
				restore.push(() => el.textContent = original)

				tl.to(counter, {
					value: target,
					duration: DURATION,
					ease: 'power1.out',
					onUpdate: render,
				}, i * STAGGER)
			})
		})

		return () => restore.forEach(fn => fn())
	})
}

export default () => { }
